<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/user-management.vue'
import axios from 'axios'
import { hasErrors } from '@utils/form'
import { httpServices } from '@utils/http-services'
import { services } from '@utils/services'
import { formatPhoneNumber } from '@utils/phone-format'

export default {
  page: {
    title: 'Create Connection',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      hasErrors,
      users: [],
      connections: [],
      groups: [],
      hardwareId: null,
      groupId: null,
      phone: null,
      orgs: [],
      sims: [],
      activeSims: [],
      inactiveSims: [],
      formLayout: 'horizontal',
      hardwareIds: [],
      form: this.$form.createForm(this, { name: 'coordinated' }),
    }
  },
  mounted() {
    httpServices.getHardwares().then((res) => {
      this.hardwareIds = res.map((i) => i.meta.id)
    })
    httpServices.getConnections().then((res) => {
      this.connections = res
    })
    axios
      .get(process.env.VUE_APP_KONSUL_API_URL + '/users/getAll', {
        headers: {
          Authorization: 'Bearer ' + this.$auth.user.access_token,
        },
      })
      .then((res) => {
        this.users = res.data.Items.map((user, i) => {
          return {
            ...user,
            key: i,
            email: user.pk.replace('USER#', ''),
          }
        })
      })
    axios
      .get(process.env.VUE_APP_KONSUL_API_URL + '/sims', {
        headers: {
          Authorization: 'Bearer ' + this.$auth.user.access_token,
        },
      })
      .then((res) => {
        this.sims = res.data.Items
        this.inactiveSims = res.data.Items
      })
    axios
      .get(process.env.VUE_APP_KONSUL_API_URL + '/permissions/groups', {
        headers: {
          Authorization: 'Bearer ' + this.$auth.user.access_token,
        },
      })
      .then((res) => {
        this.groups = res.data.Items
      })
    axios
      .get(process.env.VUE_APP_KONSUL_API_URL + '/orgs', {
        headers: {
          Authorization: 'Bearer ' + this.$auth.user.access_token,
        },
      })
      .then((res) => {
        this.orgs = res.data.Items
      })
  },
  methods: {
    filterSims(e) {
      this.hardwareId = e
      const connections = this.connections.filter(
        (i) => i.meta.hardwareId === e
      )
      const sims = this.sims.filter((i) => i.meta.hardwareId === e)

      const arr = []
      connections.forEach((conn) => {
        const sim = sims.filter((i) => i?.pk === conn?.meta?.sim)[0]
        if (sim) {
          arr.push(sim)
        }
      })

      // filter by assigned user sim and assigned user group
      if (this.$auth.user.profile.permissions.role !== 'admin') {
        httpServices.getGroups().then((res) => {
          this.activeSims = services.filterSims(
            arr,
            sims,
            res,
            this.$auth.user.email
          )
        })
      } else {
        // admin sees all sims
        this.activeSims = arr
      }

      // display inactive sims
      this.inactiveSims = sims.filter(
        (i) => !this?.activeSims?.some((e) => e.pk === i.pk)
      )
    },
    formatSIM(s) {
      const mtn = formatPhoneNumber(s?.meta?.mtn) || 'N/A'
      const imsi = s?.meta?.imsi || 'N/A'
      return `${mtn} · ${imsi}`
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = {
            hardwareId: values.hardwareId.toLowerCase(),
            locked: values.locked,
            sim: values.sim || null,
            id: values.id.toString(),
            users: values.users || [],
            orgId: this.$auth.user.profile.permissions.organization,
          }

          if (
            this.connections.filter(
              (i) =>
                i.meta.hardwareId === data.hardwareId &&
                i.meta.id.toString() === data.id.toString()
            ).length
          ) {
            this.$notification.error({
              message: `This connection id is already created for this hardware`,
              duration: 5,
            })
            return
          }

          axios
            .post(process.env.VUE_APP_KONSUL_API_URL + '/connections', data, {
              headers: {
                Authorization: 'Bearer ' + this.$auth.user.access_token,
              },
            })
            .then(
              (_res) => {
                if (values?.sim && values.sim !== 'n/a') {
                  const slotId = this.sims
                    .filter((i) => i.pk === this.connection?.meta?.sim)
                    .map((j) => j.meta.simSlot)[0]
                  const connId = this.connection?.meta?.id
                  const options = {
                    method: 'PUT',
                    url:
                      process.env.VUE_APP_KONSUL_API_URL +
                      '/api/sms/link/update',
                    headers: { 'Content-Type': 'application/json' },
                    data: {
                      hardwareId: values.hardwareId,
                      connectionId: connId.toString(),
                      slotId: slotId.toString(),
                    },
                  }
                  axios.request(options).then((_r) => {
                    this.$notification.warning({
                      message: `Changing connection`,
                    })
                    this.$router.push({
                      name: 'sim-management',
                    })
                  })
                } else {
                  this.$notification.success({
                    message: `Created connection ${data.hardwareId}: ${
                      data.sim || 'N/A'
                    } - ${data.id} successfully.`,
                  })
                  this.$router.push({
                    name: 'sim-management',
                  })
                }
              },
              () => {
                this.$notification.error({
                  message:
                    'Failed to Create Connection: That ID already exists.',
                })
                this.$router.push({
                  name: 'sim-management',
                })
              }
            )
        }
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="ant-row profile--container">
      <div class="breadcrumb--container">
        <a-breadcrumb>
          <a-breadcrumb-item href="#">
            <router-link to="/">
              <a-icon type="home" />
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="#">
            <router-link to="/sim-management">
              <a-icon type="phone" />
              <span>SIM Management</span>
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <a-icon type="plus-square" />
            Add New Connection
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <div class="form-container">
        <div
          class="header"
          style="
            padding: 1.2rem;
            margin-bottom: 0;
            text-align: center;
            background: #141414;
            border-radius: 4px 4px 0 0;
          "
        >
          <h4 style="margin: 0; font-weight: 100; color: #fff">
            <a-icon type="plus-square" style="padding-right: 4px" />
            Add New Connection
          </h4>
        </div>

        <template>
          <a-form :form="form" @submit="handleSubmit">
            <a-card>
              <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="Connection Meta Data">
                  <a-card style="width: 100%">
                    <a-row>
                      <a-col :sm="12" :md="12">
                        <a-form-item label="Connection ID">
                          <a-input-number
                            v-decorator="[
                              'id',
                              {
                                rules: [
                                  {
                                    required: true,
                                  },
                                  {
                                    type: 'number',
                                  },
                                ],
                              },
                            ]"
                            :min="1"
                            :max="1000"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="12" :md="12">
                        <a-form-item label="Select a Hardware Id">
                          <a-select
                            v-decorator="[
                              'hardwareId',
                              {
                                rules: [
                                  {
                                    required: true,
                                  },
                                ],
                              },
                            ]"
                            @change="filterSims"
                          >
                            <a-select-option
                              v-for="(h, i) in hardwareIds"
                              :key="h + i"
                              :value="h"
                            >
                              {{ h.toUpperCase() }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="12">
                        <a-form-item label="Connection Locked for SMS">
                          <a-switch
                            v-decorator="[
                              'locked',
                              { valuePropName: 'checked' },
                            ]"
                          />
                        </a-form-item>
                      </a-col>
                      <a-col :sm="16" :md="8">
                        <a-form-item v-if="hardwareId" label="SIMs">
                          <a-select v-decorator="[`sim`]">
                            <a-select-option
                              v-for="(s, i) in inactiveSims"
                              :key="i + 'sim'"
                              :value="s.pk"
                            >
                              {{ formatSIM(s) }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </a-card>
                </a-tab-pane>
              </a-tabs>

              <a-row class="submit--container">
                <a-col :sm="16" :md="8">
                  <a-form-item>
                    <a-button
                      type="primary"
                      html-type="submit"
                      :disabled="hasErrors(form.getFieldsError())"
                    >
                      Save
                    </a-button>
                  </a-form-item>
                </a-col>
                <a-col :sm="16" :md="8">
                  <a-form-item>
                    <a-button @click="$router.go(-1)"> Cancel </a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-card>
          </a-form>
        </template>
      </div>
    </div>
  </Layout>
</template>
